<template>
  <div>
    <Header />
    <div>
        <span class="navTitle">
        <span class="exhibitTitle" style="font-style: default">{{ name }}</span>
      </span>
      <br />
      <q-btn color="pink-10" style="margin-left: 7%" @click="navigate"
        >Retour</q-btn
      >
      <hr style="margin-bottom: 15px" />
    </div>
    <div>
          <q-form class="form" style="margin: auto; width: 50%;">
      <q-input
        outlined
        v-model="homePageText"
        label= "Texte pour la page d'accueil"
        style='margin-bottom: 2%'
      >
      </q-input>
      <FileSelect outlined v-model="model" :options="options" option-label="name" emit-value map-options label="Image" />

          <q-btn color="secondary" @click="send"> Ajouter </q-btn>
    </q-form>
    </div>
    <q-banner v-if="success" class="app-banner app-banner--success" dense rounded style="z-index: 10000">
      Ressource enregistrée
    </q-banner>
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import { onMounted, ref, computed } from "vue";
import { useStore } from "vuex";
import axios from "axios";
import { useRouter } from "vue-router";
import FileSelect from "../components/FileSelect.vue";

export default {
    components: {Header, FileSelect},

    setup(){
        const store = useStore();
        const router = useRouter();
        const name = computed(() => store.state.exhibitName)
        let homePageText = ref();
        let model = ref();
        let options = ref([]);
        let success = ref(false);
        const getResources = async () => {
            try {
                let url = `${process.env.VUE_APP_BASEURL}/resources`;
                let body = {
                    exhibitId: store.state.exhibitId,
                };
                let response = await axios.post(url, body);
                let results = response.data;
                options.value = results;
            } catch (error) {
                console.log(error)
            }
        }

        const send = async () =>{
          try {
            //Envoi des données de la page d'accueil
            let url = `${process.env.VUE_APP_BASEURL}/exhibit_home`;
            let body = {
              exhibitId: store.state.exhibitId,
              text: homePageText.value,
              resourceId: model.value.id
            };
            let response = await axios.post(url, body);
            if(response.status === 200){
              success.value = true;
              setTimeout(() => {
                success.value = false;
              }, 4000);
            }
          } catch (error) {
            console.log(error);
          }
        }

        const navigate = () =>{
          router.go(-1);

        }
        onMounted(getResources)
        return{
            name,
            homePageText,
            model,
            options,
            success,
            getResources,
            send,
            navigate
        }
    }

}
</script>

<style>

</style>